export class RatingServiceSubmition {
    serviceRatingId: number;
    serviceId: number;
    email: string;
    isAfterSubmit:boolean;

}